import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import {
	type LoaderFunctionArgs,
	type RouteObject,
	useRouteError
} from 'react-router-dom'

import { saveOpsImpersonateTokens } from './saveOpsImpersonateTokens'

export function loader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url)
	const tokensParam = url.searchParams.get('tokens')
	saveOpsImpersonateTokens(tokensParam)
	window.location.replace('/')
	return
}

export function OpsSaveTokensPage() {
	return <FullLoader />
}

function OpsSaveTokensError() {
	const error = useRouteError()
	const errorDescription = error instanceof Error ? error.message : String(error)

	return <pre>{errorDescription}</pre>
}

export const OpsSaveTokensRoute: RouteObject = {
	Component: OpsSaveTokensPage,
	errorElement: <OpsSaveTokensError />,
	loader,
	path: '/ops-save-tokens'
}
